<template>
  <div class="onboarding-end">
    <h1 class="onboarding-end__finish-message">
      {{ $t('components.Onboarding.label.title.finishMessage') }}
    </h1>
    <p class="onboarding-end__info-message">
      {{ $t('components.Onboarding.label.title.haveFunMessage') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'OnboardingEnd',
};
</script>

<style lang="scss" scoped>
  .onboarding-end {
    &__finish-message {
      color: var(--ds-color-text-1);
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-xl);
      line-height: var(--ds-font-line-height-normal);
    }

    &__info-message {
      color: var(---ds-color-text-2);
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-baseline);
      line-height: var(--ds-font-line-height-normal);
      margin-bottom: 48px;
    }
  }
</style>
